/**
 * @file intl.ts
 *
 * @fileoverview Exports intl utils.
 */

import { useIntl } from 'react-intl';

export type CommonTranslationsType = {
  LOADING_MESSAGE: string;
  ERROR_BACK_TO_HOME: string;
  PAY: string;
  CHOOSE_FILE: string;
  EMAIL_VALIDATION: string;
  BOOKMARKED: string;
  BOOKMARK: string;
  GO_BACK: string;
  YES: string;
  NO: string;
  OPTIONS: string;
  NOT_AVAILABLE_SHORT: string;
  TAXONOMY_EMPTY_VALUE: string;
  FIELD_REQUIRED: string;
  FIELD_NUMBER: string;
  FIELD_NUMBER_POSITIVE: string;
  FIELD_NUMBER_INTEGER: string;
  ADVERTORIAL_LABEL: string;
  EMAIL: string;
  ADD: string;
  EDIT: string;
  ADD_ANOTHER: string;
  CLOSE: string;
  TOGGLE: string;
  SELECTED: string;
  NOT_SELECTED: string;
};

// Returns commonly shared translations.
export function getCommonTranslations(): CommonTranslationsType {
  const intl = useIntl();

  return {
    LOADING_MESSAGE: intl.formatMessage({
      id: 'loading_message',
      defaultMessage: 'Loading',
    }),
    ERROR_BACK_TO_HOME: intl.formatMessage({
      id: 'error_back_to_home',
      defaultMessage: 'Go back to home',
    }),
    PAY: intl.formatMessage({
      id: 'pay',
      defaultMessage: 'Pay',
    }),
    CHOOSE_FILE: intl.formatMessage({
      id: 'choose_file',
      defaultMessage: 'Choose file',
    }),
    EMAIL_VALIDATION: intl.formatMessage({
      id: 'email_validation_format',
      defaultMessage: 'Please provide a valid email address',
    }),
    BOOKMARKED: intl.formatMessage({
      id: 'bookmarked',
      defaultMessage: 'bookmarked',
    }),
    BOOKMARK: intl.formatMessage({
      id: 'bookmark',
      defaultMessage: 'bookmark',
    }),
    GO_BACK: intl.formatMessage({
      id: 'go_back',
      defaultMessage: 'Go back',
    }),
    YES: intl.formatMessage({
      id: 'yes',
      defaultMessage: 'Yes',
    }),
    NO: intl.formatMessage({
      id: 'no',
      defaultMessage: 'No',
    }),
    OPTIONS: intl.formatMessage({
      id: 'options',
      defaultMessage: 'Options',
    }),
    NOT_AVAILABLE_SHORT: intl.formatMessage({
      id: 'not_available_short',
      defaultMessage: 'N/A',
    }),
    TAXONOMY_EMPTY_VALUE: intl.formatMessage({
      id: 'taxonomy_field_empty_value',
      defaultMessage: '-- Please choose --',
    }),
    FIELD_REQUIRED: intl.formatMessage({
      id: 'field_required',
      defaultMessage: 'Field is required',
    }),
    FIELD_NUMBER: intl.formatMessage({
      id: 'field_number',
      defaultMessage: 'The value must be a number',
    }),
    FIELD_NUMBER_POSITIVE: intl.formatMessage({
      id: 'field_number_positive',
      defaultMessage: 'Please enter a number greater than zero',
    }),
    FIELD_NUMBER_INTEGER: intl.formatMessage({
      id: 'field_number_integer',
      defaultMessage:
        'Please enter a number without any decimal points or fractions',
    }),
    ADVERTORIAL_LABEL: intl.formatMessage({
      id: 'advertorial_label',
      defaultMessage: 'Advertorial',
    }),
    EMAIL: intl.formatMessage({
      id: 'email',
      defaultMessage: 'Email',
    }),
    ADD: intl.formatMessage({
      id: 'add',
      defaultMessage: 'Add',
    }),
    EDIT: intl.formatMessage({
      id: 'edit',
      defaultMessage: 'Edit',
    }),
    ADD_ANOTHER: intl.formatMessage({
      id: 'add_another',
      defaultMessage: 'Add another',
    }),
    CLOSE: intl.formatMessage({
      id: 'close',
      defaultMessage: 'Close',
    }),
    TOGGLE: intl.formatMessage({
      id: 'toggle',
      defaultMessage: 'Toggle',
    }),
    SELECTED: intl.formatMessage({
      id: 'selected',
      defaultMessage: 'Selected',
    }),
    NOT_SELECTED: intl.formatMessage({
      id: 'not_selected',
      defaultMessage: 'Not selected',
    }),
  };
}
